import { render, staticRenderFns } from "./DetailedProduction.vue?vue&type=template&id=7958b5e6&scoped=true&"
import script from "./DetailedProduction.vue?vue&type=script&lang=js&"
export * from "./DetailedProduction.vue?vue&type=script&lang=js&"
import style0 from "./DetailedProduction.vue?vue&type=style&index=0&id=7958b5e6&lang=scss&scoped=true&"
import style1 from "./DetailedProduction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7958b5e6",
  null
  
)

export default component.exports